import { createSlice } from "@reduxjs/toolkit";
import { SessionOccurrence } from "./models/SessionOccurrence";
import { fetchSessionOccurrences } from "./slice-extensions/occurrences-slice-extension";

interface OccurrencesState {
  /** Computed occurrences keyed by session (booking) id, for the last fetched range. */
  byBooking: Record<string, SessionOccurrence[]>;
  loading: boolean;
}

const initialState: OccurrencesState = {
  byBooking: {},
  loading: false,
};

const occurrencesSlice = createSlice({
  name: "occurrences",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSessionOccurrences.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSessionOccurrences.fulfilled, (state, action) => {
      state.loading = false;
      state.byBooking[action.payload.bookingId] = action.payload.occurrences;
    });
    builder.addCase(fetchSessionOccurrences.rejected, (state) => {
      state.loading = false;
    });
  },
});

const EMPTY: SessionOccurrence[] = [];

export const selectSessionOccurrences =
  (bookingId: string) =>
  (state: { occurrences: OccurrencesState }): SessionOccurrence[] =>
    state.occurrences.byBooking[bookingId] ?? EMPTY;

export const selectOccurrencesLoading = (state: {
  occurrences: OccurrencesState;
}): boolean => state.occurrences.loading;

export default occurrencesSlice.reducer;
